"use client"

import { useState } from "react"
// Ajusta la ruta al CSS según tu estructura.
import "./css/inicio2.css"

// Asumimos que las imágenes están en la carpeta public/img/
// y se accede a ellas con rutas relativas a la raíz del sitio.
const images = [
  { src: "/img/portada8.jpg", alt: "Slide 1" },
]

const Inicio2 = () => {
  const [currentSlide, setCurrentSlide] = useState(0)

  // El useEffect para el cambio automático ha sido eliminado.

  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

  return (
    <section className="slider-container-no-anim" id="Inicio2">
      <div className="slider-wrapper-no-anim">
        <div className="slider-track-no-anim" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {images.map((image, index) => (
            <div key={index} className="slide-no-anim">
              <img
                src={image.src || "/placeholder.svg"} // Fallback a placeholder general si la imagen no carga
                alt={image.alt}
                className="slide-image-no-anim"
                onError={(e) => {
                  // Manejo de error si la imagen no se encuentra, muestra un placeholder específico
                  e.target.onerror = null // Evita bucles si el placeholder también falla
                  e.target.src = `/placeholder.svg?width=1200&height=700&text=Error+loading+${image.alt}`
                }}
              />
            </div>
          ))}
        </div>

        {/* Indicadores */}
        <div className="indicators-no-anim">
          {images.map((_, index) => (
            <button
              key={index}
              className={`indicator-no-anim ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Ir al slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Inicio2
